import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';
import ReactPlayer from 'react-player';

import {
    initiateVideo,
    pauseVideo,
    playVideo,
    videoCompleted,
    videoProgress
} from '../../containers/Video/actions';
import { onGoToNextCard } from '../../containers/Widget/actions';

import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';
import { isPortrait } from '../../utils/size';

const VideoContainer = styled.div`
    position: relative;
    width: 100%;
    margin-top: ${() => (isPortrait() ? '10%' : 0)};
    > div {
        display: flex;
        justify-content: center;
        width: 100% !important;
        height: 100% !important;
    }
`;

const getAvailableVideoSpace = () => {
    const actionContentWrapper = document.querySelector('#videoContainer');
    if (!actionContentWrapper) {
        return 180;
    }
    return actionContentWrapper.offsetHeight;
};

class Video extends Component {
    constructor() {
        super();
        this.state = {
            progress: {
                quarter: false,
                half: false,
                threeQuarter: false,
                full: false
            }
        };
    }

    static propTypes = {
        actionCompleted: PropTypes.bool.isRequired,
        actionCompletedTime: PropTypes.func.isRequired,
        actionIdentifier: PropTypes.string.isRequired,
        actionInitated: PropTypes.bool.isRequired,
        apiRequestData: PropTypes.object.isRequired,
        autoplay: PropTypes.bool.isRequired,
        beforeAdvancing: PropTypes.func.isRequired,
        cards: PropTypes.array.isRequired,
        engaged: PropTypes.bool.isRequired,
        handleSkippingEndCard: PropTypes.func.isRequired,
        initiateVideo: PropTypes.func.isRequired,
        muted: PropTypes.bool.isRequired,
        nextAction: PropTypes.object,
        onGoToNextCard: PropTypes.func.isRequired,
        pauseVideo: PropTypes.func.isRequired,
        playVideo: PropTypes.func.isRequired,
        url: PropTypes.string.isRequired,
        videoAlreadyCompleted: PropTypes.bool.isRequired,
        videoCompleted: PropTypes.func.isRequired,
        videoProgress: PropTypes.func.isRequired
    };

    onProgress = d => {
        const p = this.state.progress;

        if (d.played >= 0.25 && d.played < 0.5 && !p.quarter) {
            this.props.videoProgress(0.25);
            this.setState({ progress: { ...p, quarter: true } });
        }

        if (d.played >= 0.5 && d.played < 0.75 && !p.half) {
            if (!p.quarter) this.props.videoProgress(0.25);
            this.props.videoProgress(0.5);
            this.setState({ progress: { ...p, quarter: true, half: true } });
        }

        if (d.played >= 0.75 && d.played < 0.9 && !p.threeQuarter) {
            if (!p.quarter) this.props.videoProgress(0.25);
            if (!p.half) this.props.videoProgress(0.5);
            this.props.videoProgress(0.75);
            this.setState({
                progress: { ...p, quarter: true, half: true, threeQuarter: true }
            });
        }

        if (d.played >= 0.9 && !p.full) {
            if (!p.quarter) this.props.videoProgress(0.25);
            if (!p.half) this.props.videoProgress(0.5);
            if (!p.threeQuarter) this.props.videoProgress(0.75);
            this.props.videoProgress(1.0);
            this.setState({
                progress: { quarter: true, half: true, threeQuarter: true, full: true }
            });
            this.props.videoCompleted(
                this.props.apiRequestData,
                this.props.actionCompletedTime(),
                this.props.actionIdentifier,
                this.props.actionCompleted
            );
        }

        if (this.state.progress.full && d.played < 0.1) {
            this.setState({
                progress: {
                    quarter: false,
                    half: false,
                    threeQuarter: false,
                    full: false
                }
            });
        }
    };

    render() {
        return (
            <VideoContainer>
                <ReactPlayer
                    progressInterval={100}
                    style={{
                        width: `460px`,
                        height: isPortrait() ? `260px` : `${getAvailableVideoSpace()}px`
                    }}
                    url={this.props.url}
                    playing={this.props.autoplay}
                    volume={1}
                    muted={this.props.muted ? false : true}
                    loop={!this.props.nextAction}
                    controls={true}
                    onStart={() => {
                        this.props.initiateVideo(
                            this.props.actionIdentifier,
                            this.props.actionInitated,
                            this.props.engaged
                        );
                    }}
                    onEnded={() => {
                        // ONLY FIRES IF COMPONENT PROP LOOP === FALSE
                        this.props.videoCompleted(
                            this.props.apiRequestData,
                            this.props.actionCompletedTime(),
                            this.props.actionIdentifier,
                            this.props.actionCompleted
                        );
                        this.props.beforeAdvancing();
                        this.props.handleSkippingEndCard(
                            this.props.nextAction,
                            this.props.cards,
                            this.props.onGoToNextCard
                        );
                    }}
                    onProgress={d => this.onProgress(d)}
                    onPlay={() => this.props.playVideo()}
                    onPause={() => this.props.pauseVideo()}
                />
            </VideoContainer>
        );
    }
}

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );
        return {
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            actionCompletedTime: getActionCompletedTime(state, 'video'),
            actionInitated: state.video.actionInitated,
            actionCompleted: state.video.actionCompleted,
            cards: state.widget.cards,
            engaged: state.widget.engaged,
            nextAction,
            videoAlreadyCompleted:
                state.video.videosCompleted.length > 0
                    ? state.video.videosCompleted.includes(
                          state.widget.activeAction.identifier
                      )
                    : false
        };
    },
    {
        handleSkippingEndCard,
        initiateVideo,
        onGoToNextCard,
        playVideo,
        pauseVideo,
        videoCompleted,
        videoProgress
    }
)(Video);
